<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>科研著作绩效结果</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-spacer/>
      <v-text-field
        label="按著作名称检索…"
        v-model="searchPaper"
        v-on:keyup.enter="onSearch"
        append-icon="search"
        :append-icon-cb="onSearch"
      />
      <v-text-field
        label="按著作所属部门检索…"
        v-model="searchDept"
        v-on:keyup.enter="onSearch"
        append-icon="search"
        :append-icon-cb="onSearch"
      />
      <v-text-field
        label="按出版单位检索…"
        v-model="searchJournal"
        v-on:keyup.enter="onSearch"
        append-icon="search"
        :append-icon-cb="onSearch"
      />
    </v-toolbar>
    <v-container>
      <v-layout row wrap align-content-start>
        <v-flex xs12 sm12 md5 lg5 xl4>
          <v-subheader style="display: inline">版本名称:</v-subheader>
          <v-btn-toggle v-model="editedItem.versionName" flat>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider/>
    <v-data-table
      :headers="headers"
      :loading="loading"
      :total-items="total"
      :pagination.sync="pagination"
      item-key="dbid"
      :items="items"
      no-data-text="没有数据。"
      no-results-text="没有符合条件的记录。"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1}}
        </td>
        <td>{{ props.item.versionName}}</td>
        <td>{{ props.item.batchName}}</td>
        <td>{{ props.item.bookName}}</td>
        <td>{{ props.item.bookPublisher }}</td>
        <td>{{ props.item.bookPublishDate }}</td>
        <td>{{ props.item.departName }}</td>
        <td>{{ props.item.bookTypeName }}</td>
        <td>{{ props.item.wordCount }}</td>
        <td>{{props.item.score}}</td>
      </template>
      <!--<template slot="pageText" slot-scope="props">-->
      <!--显示第 {{props.pageStart}} - {{props.pageStop}} 条记录，共 {{props.itemsLength}} 条记录。-->
      <!--</template>-->
    </v-data-table>
  </v-card>
</template>
<script>
  export default {
    data() {
      return {
        searchPaper:'',
        searchDept:'',
        searchJournal:'',

        // 检索条件
        filters: {
          paperTitle: '',
          jouranlName:'',
          departmentName:''
        },
        // 分页条件
        pagination: {
          page: 1,
          rowsPerPage: 25,
          sortBy: 'paperTitle.asc'
        },
        // 期刊表格
        headers: [
          {text: '#', align: 'left', sortable: false, value: 'dbid', width: "2rem"},
          {text: '版本名称', align: 'left', sortable: true, value: 'versionName'},
          {text: '批次', align: 'left', sortable: true, value: 'batchName'},
          {text: '著作名称', align: 'left', sortable: true, value: 'bookName'},
          {text: '出版单位', align: 'left', sortable: false, value: 'bookPublisher'},
          {text: '著作认定时间', align: 'left', sortable: true, value: 'bookPublishDate'},
          {text: '著作负所属部门', align: 'left', sortable: true, value: 'departName'},
          {text: '著作类型名称', align: 'left', sortable: false, value: 'bookTypeName'},
          {text: '字数(万字)', align: 'left', sortable: false, value: 'wordCount'},
          {text: '绩效点', align: 'left', sortable: false, value: 'score'},
        ],

        loading: false,
        total: 0,
        pagination: {},
        items: [],

        editedItem: {
          "versionName":"",
          "batchName": "",
          "bookName": "",
          "bookPublisher":"",
          "bookPublishDate":"",
          "departName":"",
          "bookTypeName":"",
          "wordCount":"",
          "score":""
        },
        defaultItem: {
          "versionName":"",
          "batchName": "",
          "bookName": "",
          "bookPublisher":"",
          "bookPublishDate":"",
          "departName":"",
          "bookTypeName":"",
          "wordCount":"",
          "score":""
        },
      }
    },
    created() {
      // 组件创建完后获取数据，
      // 此时 data 已经被 observed 了
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      '$route': 'get',
      pagination: {handler: 'get', deep: true},
      filters: {
        deep: true,
        handler: function () {
          if (this.pagination.page !== 0) {
            this.pagination.page = 0;
          } else {
            this.get();
          }
        }
      }
    },

    methods: {
      // 检索响应函数
      onSearch() {
        this.filters.paperTitle = this.searchPaper;
        this.filters.departmentName = this.searchDept;
        this.filters.jouranlName = this.searchJournal;
        if (this.pagination.page === 0)
          this.get();
        else
          this.pagination.page = 0
      },

      paginationParams(p) {
        let params = {};
        if (p.sortBy) {
          params.sort = p.sortBy + (p.descending ? '.desc' : '.asc')
        }
        if (p.page) {
          params.page = p.page - 1
        }
        if (p.rowsPerPage) {
          params.limit = p.rowsPerPage
        }
        return params;
      },
      // 获取列表
      get() {
        window.console.log(JSON.stringify(this.query));
        const vm = this;
        const params = Object.assign(
          window.xutil.paramsPagination(vm.pagination),
          window.xutil.paramsFilters(vm.filters)
        );
        vm.loading = true;
        this.axios.get('/api/perf/bookScore/', {params: params})
          .then(rsp => {
            vm.loading = false;
            vm.items = rsp.data.items;
            vm.total = rsp.data.total;
          })
      }
    }
  }
</script>
<style scoped>
  div.toolbar__content div.input-group {
    margin-left: 1em;
  }
</style>
